var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "download_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.412a.829.829 0 01-.633-.256l-3.11-3.11a.705.705 0 01-.22-.522.769.769 0 01.22-.532.764.764 0 01.535-.24c.202-.005.38.07.535.225L11.25 12.9V5.25c0-.213.072-.391.215-.535A.726.726 0 0112 4.5c.213 0 .391.072.535.215a.726.726 0 01.215.535v7.65l1.923-1.923a.713.713 0 01.53-.22.75.75 0 01.54.235c.144.155.22.331.224.527a.699.699 0 01-.225.527l-3.11 3.11a.829.829 0 01-.632.255zM6.308 19.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283v-1.961c0-.213.072-.391.215-.535a.726.726 0 01.535-.215c.213 0 .391.072.535.215a.726.726 0 01.215.535v1.961c0 .077.032.148.096.212a.294.294 0 00.212.096h11.384a.294.294 0 00.212-.096.294.294 0 00.096-.212v-1.961c0-.213.072-.391.215-.535a.725.725 0 01.535-.215c.213 0 .391.072.535.215a.726.726 0 01.215.535v1.961c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308z",
    fill: "#fff"
  }))));
}
export default SvgDownload;